import { type FC, memo } from 'react';
import { Icon } from '@/components/elements/Icon';
import { PlayerButton } from './Button';

const FullscreenButton: FC<FullscreenButtonProps> = ({
  isFullscreen,
  onToggle,
}) => (
  <PlayerButton
    label={isFullscreen ? 'Fullscreen Off' : 'Fullscreen'}
    onClick={onToggle}
  >
    <Icon
      iconName={isFullscreen ? 'FullScreenExitOutline' : 'FullScreenOutline'}
      color="white"
    />
  </PlayerButton>
);

export default memo(FullscreenButton);

type FullscreenButtonProps = {
  isFullscreen: boolean;
  onToggle: () => void;
};
